import { useMemo } from 'react'

import { useCheckAuth } from '@/features/auth/check'

import { useGetRelatedProducts } from '@/shared/lib/hooks/useGetRelatedProducts'
import { getPhoneFromJwtToken } from '@/shared/lib/utils/jwt/get-phone-from-jwt-token'

import { useGetPurchaseBonusesQuery } from '../api/productApiSlice'

export const useProductBonus = (productId: number, skip: boolean = false) => {
	const relatedProducts = useGetRelatedProducts(productId)
	const relatedProductsIds = relatedProducts.map(({ ID }) => ID)
	const { authToken } = useCheckAuth()
	const phoneFromToken = authToken ? getPhoneFromJwtToken(authToken) : undefined
	const phone = phoneFromToken == null || phoneFromToken === '' ? undefined : String(phoneFromToken)

	const { data, isFetching, isLoading, isError, refetch } = useGetPurchaseBonusesQuery(
		{
			productIds: [...relatedProductsIds, productId],
			phone
		},
		{
			skip
		}
	)

	const discountProfit = useMemo(() => {
		if (!data?.data?.DISCOUNT_LIST?.length) return 0
		return data.data.DISCOUNT_LIST.reduce((acc, item) => {
			return acc + item.AMOUNT
		}, 0)
	}, [data?.data?.DISCOUNT_LIST])

	return {
		bonusAccrued: data?.data?.BONUS_ACCRUED,
		discountPrice: data?.data?.BONUS_PRICE || null,
		discountList: data?.data?.DISCOUNT_LIST || [],
		discountProfit,
		isLoading,
		isError,
		isFetching,
		refetch
	}
}
